import { render, staticRenderFns } from "./UCIrvineADISpecGradingQuizQ0.vue?vue&type=template&id=b146f53e&scoped=true&"
import script from "./UCIrvineADISpecGradingQuizQ0.vue?vue&type=script&lang=js&"
export * from "./UCIrvineADISpecGradingQuizQ0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b146f53e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCheckbox,VForm})
